module.exports = __webpack_public_path__ + "img/sockGif1.f1c01d83.gif";